import * as yup from 'yup';
import { fieldRequired, negativeValue } from '../../../../../constants';

export const transportValidation = yup.object().shape({
  fundingSTOPBilltoOrganization: yup.string().required(fieldRequired),
  departingSAPorJailDepartureLocation: yup.string().required(fieldRequired),
  organizationPerformingPickUpInitial: yup.string().required(fieldRequired),
  //staffTimeOverTime: yup.number().typeError('').min(0, negativeValue),
});
